import { getUpgradeLinkProps } from '@anm/helpers/upgradeLink';
import { User } from 'user';

import { userSelectors } from '../../../../store/modules/user';
import { Controls } from '../ControlsPanel';

type ControlTooltipIds = 'logo' | 'end';

const lastFrameTooltip = (profile: User | null): JSX.Element => {
  const isCreator = userSelectors.isUserCreator(profile);

  const planToUpdate = isCreator ? 'Business' : 'Creator';

  return (
    <>
      To change the way <br /> your video ends, please <br />
      <a {...getUpgradeLinkProps(`/pricing/upgrade?period=annual&plan=${planToUpdate}`, '_self')}>upgrade</a>
    </>
  );
};

const logoTooltip = () => (
  <>
    To remove Logo, please <br />
    <a {...getUpgradeLinkProps('/pricing/upgrade?period=annual&plan=Creator', '_self')}>upgrade</a>
  </>
);

const downloadTooltip = () => (
  <>
    To enable download, <br /> please{' '}
    <a {...getUpgradeLinkProps('/pricing/upgrade?period=annual&plan=Creator', '_self')}>upgrade</a>
  </>
);

const getControlTooltip = ({ id, disabled }: Controls, profile: User | null) => {
  if (!disabled) return;

  return {
    logo: logoTooltip,
    end: () => lastFrameTooltip(profile),
    download: downloadTooltip
  }[id as ControlTooltipIds];
};

export default getControlTooltip;
